import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import { brandContext } from '../brand/brandContext'; // ⬅ brand helper

Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active',
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) return savedPosition;
    if (to.hash) return { selector: to.hash };
    return { x: 0, y: 0 };
  }
});

const defaultDocumentTitle =
  process.env.VUE_APP_COMPANY_NAME_FRONTEND === 'safedig'
    ? 'Safe Dig Indiana'
    : 'HomeOfTraining';

router.beforeEach(async (toRoute, fromRoute, next) => {
  // title
  window.document.title = (toRoute.meta && toRoute.meta.title)
    ? toRoute.meta.title
    : defaultDocumentTitle;

  // brand clearing: ensure HOT theme on default login (skip for Safe Dig - keep its theme)
  if ((toRoute.name === 'Login' || toRoute.path === '/login') && process.env.VUE_APP_COMPANY_NAME_FRONTEND !== 'safedig') {
    brandContext.clear();
  }

  const isAuthenticated = !!localStorage.getItem('hot-token');

  // auth gates
  if (toRoute.meta && toRoute.meta.requiresAuth && !isAuthenticated) {
    // preserve payment-info redirection
    if (toRoute.path === '/payment-information') {
      await Promise.resolve(localStorage.setItem('redirect-path', '/payment-information'));
    }
    return next({ name: 'Login' });
  }

  if (toRoute.meta && toRoute.meta.requiresGuest && isAuthenticated) {
    // if already logged in, go to dashboard
    return next({ name: 'Dashboard' });
  }

  // preserve payment-info redirection even when auth
  if (toRoute.path === '/payment-information') {
    await Promise.resolve(localStorage.setItem('redirect-path', '/payment-information'));
  }

  // capture referral code for marketing
  if (toRoute.query && toRoute.query.ref_code) {
    localStorage.setItem('ref_code', toRoute.query.ref_code);
    const fullPathWithRefCode = `${window.location.origin}/#${toRoute.fullPath}`;
    localStorage.setItem('ref_code_route', fullPathWithRefCode);
  }

  next();
});

import roleAccessMap , { publicRoutes }  from "./../util/roleAccessMap";

router.beforeEach((to, from, next) => {
  console.log(to.path);

  const routeExists = router.getRoutes().some(r => r.path === to.path);
  if (!routeExists) {
    return next();
  }

  // Check if route is public (exact match or dynamic route pattern)
  const isPublicRoute = publicRoutes.includes(to.path) ||
    to.path.startsWith('/hig/') ||
    to.path.startsWith('/company/') ||
    to.path.startsWith('/info/') ||
    to.path.startsWith('/whopperco/');
  
  const authRequired = !isPublicRoute;
  if (!authRequired) return next();

  const role = localStorage.getItem("hot-user");
  if (!role) {
    return next("/login");
  }
if (["super-admin", "sub-admin"].includes(role)) {
    return next();
  }
  const allowedRoutes = roleAccessMap[role] || [];
  if (!allowedRoutes.includes(to.path)) {
      Vue.$toast.error('Not authorized', {
    timeout: 5000,
  });
  return next("/dashboard");
  }

  // add_employee: employee may only edit their own profile (same id); enforced by redirect
  if (to.path === '/add_employee' && to.query && to.query.id) {
    if (role === 'employee') {
      const currentUserId = localStorage.getItem('hot-user-id');
      if (currentUserId && to.query.id !== currentUserId) {
        Vue.$toast.error('Not authorized', { timeout: 5000 });
        return next('/dashboard');
      }
    }
  }

  return next();
});
export default router;
